import {DeltaEvent, DeltaEventMethodType, UpdateType} from "../../../gd/manager/delta-handler/types"
import createUpdateAction from "../../../gd/manager/delta-handler/session-events-handlers/task/create-update-action"

// const debug = "convertCalendarEventToUpdateAction"
const debug = false

export function convertCalendarEventToUpdateAction(deltaEvent:DeltaEvent) {

    debug && console.log(debug, 'process', deltaEvent)

    switch (deltaEvent.method) {
        case DeltaEventMethodType.NEW   :
            return createUpdateAction(UpdateType.EVENT_NEW, deltaEvent.data)

        case DeltaEventMethodType.DELETE:
            return createUpdateAction(UpdateType.EVENT_DELETE, {id: deltaEvent.header.event.id})

        case DeltaEventMethodType.DELTA :
            const deltaData = _.assign({}, deltaEvent.data, {id: deltaEvent.header.event.id})
            return createUpdateAction(UpdateType.EVENT_DELTA, deltaData)
    }
}